import { DEFAULT_PRICE_VERSION } from 'modules/paywall/abtests/defaultPrices/types';
import { ORGANIC_PRICE_VERSION } from 'modules/paywall/abtests/organicPrices/types';
import { MAIL_SINGLE_VERSION } from 'modules/paywall/abtests/mailSingle';
import { ACADEMY_VERSION } from 'modules/paywall/abtests/academy/types';
import { NEW_ACADEMY_VERSION } from 'modules/paywall/abtests/newAcademy/types';
import { WALKING_DESIGN_VERSION } from 'modules/paywall/abtests/walkingDesign/types';
import { WELCOME_TRIAL_VERSION } from 'modules/paywall/abtests/welcomeTrial/types';
import { PILATES_VERSION } from 'modules/paywall/abtests/pilates/types';

// TODO:
export interface IABTestsParams {
	defaultPrices?: DEFAULT_PRICE_VERSION;
	organicPrices?: ORGANIC_PRICE_VERSION;
	mailSingle?: MAIL_SINGLE_VERSION;
	academyPlanVersion?: ACADEMY_VERSION;
	newAcademyPlanVersion?: NEW_ACADEMY_VERSION;
	walkingDesign?: WALKING_DESIGN_VERSION;
	welcomeTrial?: WELCOME_TRIAL_VERSION;
	pilates?: PILATES_VERSION;
}

// find version parameter if presented in searchParams
const getVersion = <T>(
	versionEnumType: { [s: string]: T } | ArrayLike<T>,
	searchParams: URLSearchParams,
	value = 'true',
): T | undefined => {
	for (const param of Object.values(versionEnumType)) {
		if (searchParams.get(param as unknown as string) === value) return param;
	}
	return undefined;
};

export const getABTestsParams = (urlSearchParams: URLSearchParams): IABTestsParams => {
	const defaultPrices = getVersion(DEFAULT_PRICE_VERSION, urlSearchParams);
	const organicPrices = getVersion(ORGANIC_PRICE_VERSION, urlSearchParams);
	const mailSingle = getVersion(MAIL_SINGLE_VERSION, urlSearchParams);
	const walkingDesign = getVersion(WALKING_DESIGN_VERSION, urlSearchParams);
	const welcomeTrial = getVersion(WELCOME_TRIAL_VERSION, urlSearchParams);
	const pilates = getVersion(PILATES_VERSION, urlSearchParams);

	const academyPlanVersion =
		(urlSearchParams.get('academyPlanVersion') as ACADEMY_VERSION) ?? undefined;
	const newAcademyPlanVersion =
		(urlSearchParams.get('newAcademyPlanVersion') as NEW_ACADEMY_VERSION) ?? undefined;

	const state = {
		defaultPrices,
		organicPrices,
		mailSingle,
		academyPlanVersion,
		newAcademyPlanVersion,
		walkingDesign,
		welcomeTrial,
		pilates,
	};

	return state;
};
